/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect, useRef, useCallback } from "react";
import "../css/campaignListcss.css";
import "../css/lineclamp2css.css";
import Pagination from "@mui/material/Pagination";
import { useNavigate } from "react-router-dom";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import ScrollToTopButton from "./ScrollToTopButton";
import { useTranslation } from "react-i18next";
import { DocCenterService } from "../services/docCenterService";
import { CmsService } from "../services/cmsService";
import { MultiSelect } from "react-multi-select-component";
import downloadFile from "../utils/fileUtils";
import Swal from "sweetalert2";
import { Icon } from "./ui";
import functionConstants from "../utils/functionConstants";
import { Button, Grid, Stack, Tooltip } from "@mui/material";

function DocCenter() {
  // eslint-disable-next-line no-unused-vars
  const [savedLanguage, setSaveLanguage] = useState();
  const functionId = localStorage.getItem("functionId");
  const functionList = String(functionId).split(",");
  const { t, i18n } = useTranslation();
  const inputRefTitleEnglish = useRef(null);
  const inputRefEffectiveDateFrom = useRef(null);
  const inputRefEffectiveDateTo = useRef(null);
  const [selectedValue, setSelectedValue] = useState();
  const [Page, setPage] = useState();
  const [Max, setMax] = useState();
  const [Orderby, setOrderby] = useState("updatedDate");
  const [OrderSequence, setOrderSequence] = useState("desc");
  const [titleEnglish, setTitleEnglish] = useState();
  const [effectiveDateFrom, setEffectiveDateFrom] = useState(null);
  const [effectiveDateTo, setEffectiveDateTo] = useState(null);
  const [visibility, setVisibility] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [categories, setCategories] = useState([]);
  const [preResult, setPreResult] = useState();
  const [nextResult, setNextResult] = useState();
  const [pagination, setPagination] = useState({});
  const [isMobileScreen, setIsMobileScreen] = useState(
    window.innerWidth <= 1250 ? true : false
  );
  const [mainCategories, setMainCategories] = useState([]);
  const [selectedVis, setSelectedVis] = useState([]);
  const [selectedMainCategory, setSelectedMainCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  // eslint-disable-next-line
  const [isXsMobileScreen, setXsIsMobileScreen] = useState(
    window.screen.width <= 385 ? true : false
  );
  const [postData, setPostData] = useState({
    pageableParameter: {
      pageNumber: 0,
      pageSize: 10,
      orderBy: "updatedDate",
      orderSequence: "desc",
    },
    documentCenterParameter: {
      titleEng: titleEnglish ?? "",
      effectiveDateFrom: effectiveDateFrom,
      effectiveDateTo: effectiveDateTo,
      visibilityList: [],
      mainCategoryId: null,
      subCategoryId: null,
    },
  });

  useEffect(() => {
    setSaveLanguage(i18n.language);
  }, [i18n.language]);

  const overrideStrings = {
    allItemsAreSelected: t("documentCenterPage.allItemsAreSelected"),
    clearSearch: t("documentCenterPage.clearSearch"),
    clearSelected: t("documentCenterPage.clearSelected"),
    noOptions: t("common.noRecord"),
    search: t("common.search"),
    selectAll: t("documentCenterPage.selectAll"),
    selectAllFiltered: t("documentCenterPage.selectAllFiltered"),
    selectSomeItems: t("documentCenterPage.visibility"),
  };

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setPostData({
      pageableParameter: {
        pageNumber: 0,
        pageSize: event.target.value,
        orderBy: Orderby,
        orderSequence: OrderSequence,
      },
      documentCenterParameter: {
        titleEng: titleEnglish,
        effectiveDateFrom: effectiveDateFrom,
        effectiveDateTo: effectiveDateTo,
        visibilityList: selectedVis,
        mainCategoryId: selectedMainCategory,
        subCategoryId: selectedSubCategory,
      },
    });
  };

  const handlePageChange = (event) => {
    setPage(event);
    setPostData({
      pageableParameter: {
        pageNumber: event - 1,
        pageSize: pagination.pageSize,
        orderBy: Orderby,
        orderSequence: OrderSequence,
      },
      documentCenterParameter: {
        titleEng: titleEnglish,
        effectiveDateFrom: effectiveDateFrom,
        effectiveDateTo: effectiveDateTo,
        visibilityList: selectedVis,
        mainCategoryId: selectedMainCategory,
        subCategoryId: selectedSubCategory,
      },
    });
  };

  const handleCampaignChange = () => {
    if (
      inputRefEffectiveDateFrom.current.value >
      inputRefEffectiveDateTo.current.value
    ) {
      Swal.fire({
        icon: "error",
        title: t("errors.invalidDateRange"),
        text: t("errors.startDateAfterEndDate"),
      });
    } else {
      setTitleEnglish(inputRefTitleEnglish.current.value.trim());
      setEffectiveDateFrom(
        inputRefEffectiveDateFrom.current.value === ""
          ? null
          : inputRefEffectiveDateFrom.current.value
      );
      setEffectiveDateTo(
        inputRefEffectiveDateTo.current.value === ""
          ? null
          : inputRefEffectiveDateTo.current.value
      );
      setPostData({
        pageableParameter: {
          pageNumber: 0,
          pageSize: pagination.pageSize,
          orderBy: Orderby,
          orderSequence: OrderSequence,
        },
        documentCenterParameter: {
          titleEng: inputRefTitleEnglish.current.value.trim(),
          effectiveDateFrom:
            inputRefEffectiveDateFrom.current.value === ""
              ? null
              : inputRefEffectiveDateFrom.current.value,
          effectiveDateTo:
            inputRefEffectiveDateTo.current.value === ""
              ? null
              : inputRefEffectiveDateTo.current.value,
          visibilityList: selectedVis,
          mainCategoryId: selectedMainCategory,
          subCategoryId: selectedSubCategory,
        },
      });
    }
  };

  const handleResetChange = () => {
    inputRefTitleEnglish.current.value = "";
    inputRefEffectiveDateFrom.current.value = "";
    inputRefEffectiveDateTo.current.value = "";
    setTitleEnglish("");
    setEffectiveDateFrom(null);
    setEffectiveDateTo(null);
    setSelected([]);
    setSelectedMainCategory(null);
    setSelectedSubCategory(null);
    // setVisibility([]);
    // setMainCategory(null);
    // setSubCategory(null);
    setPage(1);
    setPostData({
      pageableParameter: {
        pageNumber: 0,
        pageSize: pagination.pageSize,
        orderBy: "updatedDate",
        orderSequence: "desc",
      },
      documentCenterParameter: {
        titleEng: "",
        effectiveDateFrom: null,
        effectiveDateTo: null,
        visibilityList: [],
        mainCategoryId: null,
        subCategoryId: null,
      },
    });
  };

  useEffect(() => {
    var docCenterService = new DocCenterService();
    docCenterService
      .retrieveDocumentCenterListByPostdata(postData)
      .then((value) => {
        return value.data;
      })
      .then((data) => {
        if (data.documentCenterList) {
          setCampaigns(data.documentCenterList);
        } else {
          setCampaigns([]);
        }
        setPagination(data.pagination);

        const pageNumber = parseInt(data.pagination.pageNumber);
        const pageSize = parseInt(data.pagination.pageSize);
        const totalPages = parseInt(data.pagination.totalPages);
        const totalNumberOfRecords = parseInt(
          data.pagination.totalNumberOfRecords
        );
        if (pageNumber === "0") {
          setPreResult(1);
          setNextResult(pageSize);
        } else {
          setPreResult(pageNumber * pageSize + 1);
          setNextResult((pageNumber + 1) * pageSize);
        }

        if (data.pagination.hasNext === "false" && pageNumber !== 0) {
          setPreResult((totalPages - 1) * pageSize + 1);
          setNextResult(totalNumberOfRecords);
        }
      })
      .catch((error) => console.error(error));

    var cmsService = new CmsService();
    cmsService
      .retrieveCategoryList()
      .then((value) => {
        return value.data;
      })
      .then((data) => {
        setCategories(data.firstLevelCategoryList);
      })
      .catch((error) => console.error(error));
  }, [postData, selectedValue, Page]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [Page]);

  useEffect(() => {
    function handleResize() {
      setIsMobileScreen(window.innerWidth <= 1250);
      setXsIsMobileScreen(window.screen.width <= 385);
    }

    handleResize();
    window.addEventListener("resize", handleResize);

    // Add this block to update isMobileScreen when the screen size is larger than 1207 pixels
    return () => {
      window.removeEventListener("resize", handleResize);
      setIsMobileScreen(false);
      setXsIsMobileScreen(false);
    };
  }, []);

  const handleDelete = async (id) => {
    // Show a confirmation dialog before deleting the URL
    const result = await Swal.fire({
      icon: "warning",
      title: t("common.deleteConfirmText"),
      showCancelButton: true,
      confirmButtonColor: "#dc3545", // set confirm button color to red
      confirmButtonText: t("common.delete"),
      cancelButtonText: t("common.cancel"),
    });

    // Check if the user clicked the delete button
    if (result.isConfirmed) {
      var docCenterService = new DocCenterService();
      docCenterService.deleteDocumentCenterList(id).then((value) => {
        if (value.status === 200) {
          window.location.reload();
        } else {
          // Handle error
          console.error("Error deleting item");
        }
      });
    }
  };

  const handleOrder = (event) => {
    handleOrderBy(event);
    handlePostData(event);
  };

  const handleOrderBy = (event) => {
    setOrderby(event);
  };

  const handlePostData = (event) => {
    if (OrderSequence === "desc") {
      setOrderSequence("asc");
      setPostData({
        pageableParameter: {
          pageNumber: pagination.pageNumber,
          pageSize: pagination.pageSize,
          orderBy: event,
          orderSequence: "asc",
        },
        documentCenterParameter: {
          titleEng: titleEnglish,
          effectiveDateFrom: effectiveDateFrom,
          effectiveDateTo: effectiveDateTo,
          visibilityList: selectedVis,
          mainCategoryId: selectedMainCategory,
          subCategoryId: selectedSubCategory,
        },
      });
    } else {
      setOrderSequence("desc");
      setPostData({
        pageableParameter: {
          pageNumber: pagination.pageNumber,
          pageSize: pagination.pageSize,
          orderBy: event,
          orderSequence: "desc",
        },
        documentCenterParameter: {
          titleEng: titleEnglish,
          effectiveDateFrom: effectiveDateFrom,
          effectiveDateTo: effectiveDateTo,
          visibilityList: selectedVis,
          mainCategoryId: selectedMainCategory,
          subCategoryId: selectedSubCategory,
        },
      });
    }
  };

  const ondownloadFile = (fileId, fileName) => {
    downloadFile(fileId, fileName);
  };

  const navigate = useNavigate();

  const EditDocument = (event) => {
    navigate("/EditDocument", { state: { event } });
  };

  // const ViewDetail = (event) => {
  //   navigate('/CampaignDetail',{state:{event}});
  // }
  const FileDownloadButton = useCallback(
    ({ fileId, fileName }) => (
      <Tooltip title={fileName} arrow>
        <Button
          startIcon={<Icon src="file" />}
          onClick={() => downloadFile(fileId, fileName)}
          size="large"></Button>
      </Tooltip>
    ),
    []
  );

  useEffect(() => {
    var docCenterService = new DocCenterService();
    docCenterService
      .retrieveBrokerList()
      .then((value) => {
        return value.data;
      })
      .then((data) => {
        setMax(data.length);

        // Create an object to store combined broker codes by broker name
        const brokerCodesByBrokerName = {};

        // Process the data and combine broker codes
        data.forEach((broker) => {
          const brokerName = broker.brokerName;
          const brokerCode = broker.brokerCode;

          if (brokerCodesByBrokerName[brokerName]) {
            // Broker name already exists, add the broker code
            brokerCodesByBrokerName[brokerName].value += `, ${brokerCode}`;
            brokerCodesByBrokerName[brokerName] = {
              label: `${brokerName} (${brokerCodesByBrokerName[brokerName].value})`,
              value: brokerCodesByBrokerName[brokerName].value,
            };
          } else {
            // New broker name, initialize the value with the broker code
            brokerCodesByBrokerName[brokerName] = {
              label: `${brokerName}(${brokerCode})`,
              value: brokerCode,
            };
          }
        });

        // Convert the object values back to an array
        const formattedOptions = Object.values(brokerCodesByBrokerName);

        setVisibility(formattedOptions);
      });
  }, []);

  const [selected, setSelected] = useState([]);

  const handleSelect = (selected) => {
    const result = selected.map((item) => item.value.split(", ")).flat(); // Use flat to flatten the array

    if (result.length === Max) {
      setSelectedVis([]);
    } else {
      setSelectedVis(result);
    }
    setSelected(selected);
  };

  useEffect(() => {
    var cmsService = new CmsService();
    cmsService
      .retrieveCategoryList()
      .then((value) => {
        return value.data;
      })
      .then((data) => {
        setMainCategories(data.firstLevelCategoryList);
      });
  }, []);

  const handleMainCategoryChange = (event) => {
    const selectedMainCategoryId = event.target.value;
    setSelectedMainCategory(selectedMainCategoryId);
    setSelectedSubCategory(null);
  };

  const handleSubCategoryChange = (event) => {
    const selectedSubCategoryId = event.target.value;
    setSelectedSubCategory(selectedSubCategoryId);
  };

  const subCategoryOptions = selectedMainCategory
    ? mainCategories.find(
        (category) => category.categoryId === selectedMainCategory
      )?.secondLevelCategoryList
    : null;

  const viewDocument = (event) => {
    navigate("/ViewDocument", { state: { event } });
  };

  return (
    <>
      {isMobileScreen ? (
        <div className="w-full ">
          <div className="flex ">
            <h1 className="text-header font-bold text-ft-light w-3/4">
              {t("documentCenterPage.documentCenter")}
            </h1>

            {functionList.includes(
              String(functionConstants.DOCUMENT_CENTER_UPLOAD)
            ) ? (
              <a
                className="no-underline w-1/4 text-tableHeader bg-ft-light text-center text-white py-2 px-3 rounded hover:bg-ft active:bg-white active:text-ft active:ring-1 active:ring-ft"
                href="/CreateDoc">
                {t("common.upload")}
              </a>
            ) : (
              <></>
            )}
          </div>

          <div className="border border-red-300 py-3 px-3 rounded-md mt-3">
            {!functionList.includes(
              String(functionConstants.DOCUMENT_CENTER_VISIBILITY)
            ) ? (
              <></>
            ) : (
              <>
                <div className="mt-3 text-content">
                  <label>{t("documentCenterPage.visibility")}</label>
                  <MultiSelect
                    options={visibility}
                    value={selected}
                    onChange={handleSelect}
                    labelledBy={t("documentCenterPage.visibility")}
                    isCreatable={false}
                    overrideStrings={overrideStrings}
                  />
                </div>
              </>
            )}
            <div className=" mt-2">
              <div className="md:flex w-full r:flex-col">
                <div className="md:w-1/2 md:mr-4 text-content w-full">
                  <label>{t("cms.mainCategory") + ":"}</label>
                  <br></br>
                  <select
                    value={selectedMainCategory ?? ""}
                    onChange={handleMainCategoryChange}
                    className="rounded border ring-ft h-10 w-full text-content">
                    <option value="" className="text-word ">
                      {t("cms.select") + t("cms.mainCategory")}
                    </option>
                    {mainCategories.map((category) => (
                      <option
                        key={category.categoryId}
                        value={category.categoryId}
                        className="text-word text-content">
                        {savedLanguage === "en"
                          ? category.categoryNameEng
                          : savedLanguage === "cn"
                          ? category.categoryNameCn
                          : category.categoryNameHk}
                      </option>
                    ))}
                  </select>
                </div>

                {subCategoryOptions && (
                  <div className="r:mt-2 md:w-1/2 text-content">
                    <label>{t("cms.subCategory") + ":"}</label>
                    <br></br>
                    <select
                      value={selectedSubCategory ?? ""}
                      onChange={handleSubCategoryChange}
                      className="rounded border  ring-ft h-10 w-full text-content">
                      <option value="">
                        {" "}
                        {t("cms.select") + t("cms.subCategory")}
                      </option>
                      {subCategoryOptions.map((subCategory) => (
                        <option
                          key={subCategory.categoryId}
                          value={subCategory.categoryId}>
                          {savedLanguage === "en"
                            ? subCategory.categoryNameEng
                            : savedLanguage === "cn"
                            ? subCategory.categoryNameCn
                            : subCategory.categoryNameHk}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            </div>

            <div className="flex mt-2 text-content">
              <div className="w-full ">
                <span>{t("documentCenterPage.title")}</span>
                <span className="input-search">
                  <input
                    data-input=""
                    className="form-control text-content"
                    type="search"
                    placeholder={t("documentCenterPage.title")}
                    maxLength="500"
                    id="Input_SearchCampaignName"
                    ref={inputRefTitleEnglish}
                    style={{ userSelect: "auto" }}
                  />
                </span>
              </div>
            </div>
            <div className="flex mt-2 text-content">
              <div className="w-full ">
                <span>{t("documentCenterPage.effectiveDateFrom")}</span>
                <span className="input-search">
                  <input
                    type="date"
                    className="form-control text-content"
                    placeholder="Effective Period From"
                    maxLength="500"
                    ref={inputRefEffectiveDateFrom}
                    id="Input_SearchCampaignCode"
                    style={{ userSelect: "auto" }}
                  />
                </span>
              </div>
            </div>
            <div className="flex mt-2 text-content">
              <div className="w-full ">
                <span>{t("documentCenterPage.effectiveDateTill")}</span>
                <span className="input-search">
                  <input
                    type="date"
                    className="form-control text-content"
                    placeholder="Effective Period To"
                    maxLength="500"
                    ref={inputRefEffectiveDateTo}
                    id="Input_SearchCampaignCode2"
                    style={{ userSelect: "auto" }}
                  />
                </span>
              </div>
            </div>

            <div className="flex mt-4 justify-end">
              <div className="mr-5 text-tableHeader">
                <a
                  onClick={() => handleCampaignChange()}
                  className="no-underline cursor-pointer bg-ft-light text-white px-3 py-2 rounded hover:bg-ft active:bg-white active:text-ft active:ring-1 active:ring-ft">
                  {t("common.search")}
                </a>
              </div>
              <div className="text-tableHeader">
                <a
                  onClick={() => handleResetChange()}
                  className="no-underline cursor-pointer bg-white text-ft-light ring-ft-light ring-1 px-3 py-2 rounded hover:bg-ft hover:text-white active:bg-ft-light active:ring-1 active:ring-ft">
                  {t("common.reset")}
                </a>
              </div>
            </div>
          </div>

          <div className="mt-3 text-tableHeader">
            <p>
              {t("common.showPerPage1")}
              <select
                id="countries"
                aria-label="Select page size"
                className="mx-2 w-20 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                value={selectedValue}
                onChange={handleChange}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              {t("common.showPerPage2")}
            </p>
          </div>

          <div className="flex">
            <table className=" flex w-full bg-white">
              <thead className="sm:w-1/5 w-2/5 text-white text-mobileLandingContent ">
                {campaigns || campaigns.length !== 0
                  ? campaigns.map((campaignMobileHead) => {
                      return (
                        <tr
                          className="pl-1 bg-ft-light flex flex-col mb-2 border border-slate-300"
                          key={campaignMobileHead.documentCenterId}>
                          <th className="h-12 font-bold ">
                            {t("documentCenterPage.title")}
                          </th>
                          <th className="h-6 font-bold">
                            {t("cms.mainCategory")}
                          </th>
                          <th className="h-6 font-bold">
                            {t("cms.subCategory")}
                          </th>
                          <th className="h-6 font-bold">
                            {t("common.publishDate")}
                          </th>
                          <th className="h-6 font-bold">
                            {t("common.expiryDate")}
                          </th>
                          <th className="h-12 font-bold">
                            {t("common.file")}(1)
                          </th>
                          <th className="h-12 font-bold">
                            {t("common.file")}(2)
                          </th>
                          <th className="h-12 font-bold mb-1">
                            {t("common.file")}(3)
                          </th>
                          {functionList.includes(
                            String(functionConstants.DOCUMENT_CENTER_EDIT)
                          ) ? (
                            <>
                              <th className="h-6 font-bold mb-halfmobile">
                                {t("common.edit")}
                              </th>
                            </>
                          ) : (
                            <></>
                          )}
                          {functionList.includes(
                            String(functionConstants.DOCUMENT_CENTER_DELETE)
                          ) ? (
                            <>
                              <th className="text-mobileLandingContent font-bold mb-mobile ">
                                {t("common.delete")}
                              </th>
                            </>
                          ) : (
                            <></>
                          )}
                        </tr>
                      );
                    })
                  : ""}
              </thead>
              <tbody className="sm:w-4/5 w-3/5 text-mobileLandingContent ">
                {campaigns.map((campaignMobileBody) => {
                  const startDate = new Date(
                    campaignMobileBody.effectiveDateFrom
                  );
                  const endDate = new Date(campaignMobileBody.effectiveDateTo);
                  const formattedStartDate = startDate
                    .toISOString()
                    .slice(0, 10);
                  const formattedEndDate =
                    endDate.toISOString().slice(0, 10) === "2099-12-31"
                      ? "N/A"
                      : endDate.toISOString().slice(0, 10);

                  if (campaignMobileBody.file1Name === null) {
                    campaignMobileBody.file1Name = "";
                  }
                  campaignMobileBody.level1CategoryId = String(
                    campaignMobileBody.level1CategoryId
                  );
                  campaignMobileBody.level2CategoryId = String(
                    campaignMobileBody.level2CategoryId
                  );

                  if (campaignMobileBody.level2CategoryId === null) {
                    campaignMobileBody.level2CategoryId = "";
                  }

                  const isExpired =
                    new Date() >= endDate ? <>{t("common.expired")}</> : null;

                  const isUnposted =
                    new Date() <= startDate ? (
                      <>{t("common.unposted")}</>
                    ) : null;

                  return (
                    <tr
                      className="flex flex-col border border-slate-300 mb-2"
                      key={campaignMobileBody.documentCenterId}>
                      <td className="pl-3 pr-3 h-12 line-clamp-2">
                        <a
                          className="no-underline cursor-pointer text-ft-light hover:text-ft"
                          onClick={() => viewDocument(campaignMobileBody)}>
                          {isExpired}
                          {isUnposted}
                          {savedLanguage === "en"
                            ? campaignMobileBody.titleEng
                            : savedLanguage === "cn"
                            ? campaignMobileBody.titleCn
                            : campaignMobileBody.titleHk}
                        </a>
                      </td>
                      <td className="pl-3 pr-3 h-6 line-clamp-1">
                        {categories
                          .filter(
                            (cat) =>
                              cat.categoryId ===
                              campaignMobileBody.level1CategoryId
                          )
                          .map((mainCat) => mainCat.categoryEnglish)}
                      </td>
                      <td className="pl-3 pr-3 h-6 line-clamp-1">
                        {categories
                          .filter(
                            (cat) =>
                              cat.categoryId ===
                              campaignMobileBody.level1CategoryId
                          )
                          .flatMap((mainCat) => {
                            if (mainCat.secondLevelCategoryList) {
                              return mainCat.secondLevelCategoryList
                                .filter(
                                  (subCat) =>
                                    subCat.categoryId ===
                                    campaignMobileBody.level2CategoryId
                                )
                                .map((mainCat) => mainCat.categoryEnglish);
                            }
                            return [];
                          })}
                      </td>
                      <td className="pl-3 pr-3 h-6">{formattedStartDate}</td>
                      <td className="pl-3 pr-3 h-6">{formattedEndDate}</td>
                      <td className="pl-3 pr-3 h-12">
                        <div>
                          <a
                            className="no-underline cursor-pointer	 text-ft-light hover:text-ft line-clamp-2"
                            onClick={() =>
                              ondownloadFile(
                                campaignMobileBody.file1Id,
                                campaignMobileBody.file1Name
                              )
                            }>
                            {campaignMobileBody.file1Name}
                          </a>
                        </div>
                      </td>
                      <td className="pl-3 pr-3 h-12">
                        <div>
                          <a
                            className="no-underline cursor-pointer	 text-ft-light hover:text-ft line-clamp-2"
                            onClick={() =>
                              ondownloadFile(
                                campaignMobileBody.file2Id,
                                campaignMobileBody.file2Name
                              )
                            }>
                            {campaignMobileBody.file2Name}
                          </a>
                        </div>
                      </td>
                      <td className="pl-3 pr-3 h-12 mb-1">
                        <div>
                          <a
                            className="no-underline cursor-pointer	 text-ft-light hover:text-ft line-clamp-2 "
                            onClick={() =>
                              ondownloadFile(
                                campaignMobileBody.file3Id,
                                campaignMobileBody.file3Name
                              )
                            }>
                            {campaignMobileBody.file3Name}
                          </a>
                        </div>
                      </td>

                      {functionList.includes(
                        String(functionConstants.DOCUMENT_CENTER_EDIT)
                      ) ? (
                        <>
                          <td className="pl-3 pr-3 h-6 mb-1">
                            <a onClick={() => EditDocument(campaignMobileBody)}>
                              <Icon src="edit" color="primary" />
                            </a>
                          </td>
                        </>
                      ) : (
                        <></>
                      )}
                      {functionList.includes(
                        String(functionConstants.DOCUMENT_CENTER_DELETE)
                      ) ? (
                        <>
                          <td className="pl-3 pr-3 mb-mobile">
                            <a
                              onClick={() =>
                                handleDelete(
                                  campaignMobileBody.documentCenterId
                                )
                              }>
                              <Icon src="delete" color="primary" />
                            </a>
                          </td>
                        </>
                      ) : (
                        <></>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="flex flex-col items-center text-tableHeader">
            <div>
              {pagination.totalNumberOfRecords === 0 ? (
                <p className="text-sm text-gray-700">{t("common.noRecord")}</p>
              ) : (
                <p className="text-sm text-gray-700">
                  {t("common.showPage1")}
                  <span className="font-medium"> {preResult}</span>{" "}
                  {t("common.showPage2")}{" "}
                  <span className="font-medium">{nextResult}</span>{" "}
                  {t("common.showPage3")}{" "}
                  <span className="font-medium">
                    {pagination.totalNumberOfRecords}
                  </span>{" "}
                  {t("common.showPage4")}
                </p>
              )}
            </div>
            {pagination && pagination.totalNumberOfRecords > 0 && (
              <Stack spacing={2}>
                <Pagination
                  page={parseInt(pagination.pageNumber) + 1}
                  shape={"circular"}
                  count={
                    pagination.totalNumberOfRecords &&
                    pagination.pageSize &&
                    !isNaN(pagination.totalNumberOfRecords) &&
                    !isNaN(pagination.pageSize)
                      ? Math.ceil(
                          pagination.totalNumberOfRecords / pagination.pageSize
                        )
                      : 0
                  }
                  onChange={(e, value) => handlePageChange(value)}
                />
              </Stack>
            )}
          </div>
          <ScrollToTopButton />
        </div>
      ) : (
        <div className="w-deflaut px-2">
          <div className="flex justify-content-between align-items-center my-3">
            <div className="text-header text-ft-light font-bold">
              <p>{t("documentCenterPage.documentCenter")}</p>
            </div>
            <div className="">
              {functionList.includes(
                String(functionConstants.DOCUMENT_CENTER_UPLOAD)
              ) ? (
                <a
                  className="no-underline text-tableHeader bg-ft-light text-white px-3 py-2 rounded hover:bg-ft active:bg-white active:text-ft active:ring-1 active:ring-ft"
                  href="/CreateDoc">
                  {t("common.upload")}
                </a>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="border border-red-300 py-2 px-3 rounded-md ">
            {!functionList.includes(
              String(functionConstants.DOCUMENT_CENTER_VISIBILITY)
            ) ? (
              <></>
            ) : (
              <>
                <div className="mt-3 text-content">
                  <label>{t("documentCenterPage.visibility")}</label>
                  <MultiSelect
                    options={visibility}
                    value={selected}
                    onChange={handleSelect}
                    labelledBy={t("documentCenterPage.visibility")}
                    isCreatable={false}
                    overrideStrings={overrideStrings}
                  />
                </div>
              </>
            )}
            <div className="mt-4">
              <div className="md:flex w-full r:flex-col">
                <div className="md:w-1/2 md:mr-4 text-content w-full">
                  <label>{t("cms.mainCategory") + ":"}</label>
                  <br></br>
                  <select
                    value={selectedMainCategory ?? ""}
                    onChange={handleMainCategoryChange}
                    className="rounded border ring-ft h-10 w-full text-content">
                    <option value="" className="text-word ">
                      {t("cms.select") + t("cms.mainCategory")}
                    </option>
                    {mainCategories.map((category) => (
                      <option
                        key={category.categoryId}
                        value={category.categoryId}
                        className="text-word text-content">
                        {savedLanguage === "en"
                          ? category.categoryNameEng
                          : savedLanguage === "cn"
                          ? category.categoryNameCn
                          : category.categoryNameHk}
                      </option>
                    ))}
                  </select>
                </div>

                {subCategoryOptions && (
                  <div className="r:mt-2 md:w-1/2 text-content">
                    <label>{t("cms.subCategory") + ":"}</label>
                    <br></br>
                    <select
                      value={selectedSubCategory ?? ""}
                      onChange={handleSubCategoryChange}
                      className="rounded border  ring-ft h-10 w-full text-content">
                      <option value="">
                        {" "}
                        {t("cms.select") + t("cms.subCategory")}
                      </option>
                      {subCategoryOptions.map((subCategory) => (
                        <option
                          key={subCategory.categoryId}
                          value={subCategory.categoryId}>
                          {savedLanguage === "en"
                            ? subCategory.categoryNameEng
                            : savedLanguage === "cn"
                            ? subCategory.categoryNameCn
                            : subCategory.categoryNameHk}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            </div>

            <div className="flex mt-4 text-content">
              <div className="w-full ">
                <span>{t("documentCenterPage.title")}</span>
                <span className="input-search">
                  <input
                    data-input=""
                    className="form-control text-content"
                    type="search"
                    placeholder={t("documentCenterPage.title")}
                    maxLength="500"
                    id="Input_SearchCampaignName"
                    ref={inputRefTitleEnglish}
                    style={{ userSelect: "auto" }}
                  />
                </span>
              </div>
            </div>
            <div className="flex mt-4">
              <div className="w-1/2 mr-4 text-content">
                <span>{t("documentCenterPage.effectiveDateFrom")}</span>
                <span className="input-search">
                  <input
                    type="date"
                    className="form-control text-content"
                    placeholder="Effective Period From"
                    maxLength="500"
                    ref={inputRefEffectiveDateFrom}
                    id="Input_SearchCampaignCode"
                    style={{ userSelect: "auto" }}
                  />
                </span>
              </div>
              <div className="w-1/2 text-content">
                <span>{t("documentCenterPage.effectiveDateTill")}</span>
                <span className="input-search text-content">
                  <input
                    type="date"
                    className="form-control text-content"
                    placeholder="Effective Period To"
                    maxLength="500"
                    ref={inputRefEffectiveDateTo}
                    id="Input_SearchCampaignCode2"
                    style={{ userSelect: "auto" }}
                  />
                </span>
              </div>
            </div>
            <div className="flex mt-5 justify-end">
              <div className="mr-5 mb-3">
                <a
                  onClick={() => handleCampaignChange()}
                  className="no-underline text-tableHeader cursor-pointer bg-ft-light text-white px-3 py-2 rounded hover:bg-ft active:bg-white active:text-ft active:ring-1 active:ring-ft">
                  {t("common.search")}
                </a>
              </div>
              <div className="">
                <a
                  onClick={() => handleResetChange()}
                  className="no-underline text-tableHeader cursor-pointer bg-white text-ft-light ring-ft-light ring-1 px-3 py-2 rounded hover:bg-ft hover:text-white active:bg-ft-light active:ring-1 active:ring-ft">
                  {t("common.reset")}
                </a>
              </div>
            </div>
          </div>

          <div className="mr-5 mt-4 text-content">
            <p>
              {t("common.showPerPage1")}
              <select
                id="countries"
                aria-label="Select page size"
                className="mx-2 w-20 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                value={selectedValue}
                onChange={handleChange}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              {t("common.showPerPage2")}
            </p>
          </div>
          <div className="w-table flex ">
            <div className="overflow-x w-full ">
              <table className="table-fixed overflow-scroll w-full block">
                <thead>
                  <tr className="border border-slate-300 text-tableHeader">
                    <th
                      className=" hover:text-ft-light cursor-pointer pl-5 h-8"
                      onClick={() => handleOrder("titleEng")}>
                      <div className="inline-block h-6 w-docName">
                        {t("documentCenterPage.title")}
                        <svg
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          className="inline-block w-4 h-4 ml-1">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path>
                        </svg>
                      </div>
                    </th>
                    <th className=" h-8 ">
                      <div className="inline-block h-6 w-comAns mr-3">
                        {t("cms.mainCategory")}
                      </div>
                    </th>
                    <th className=" h-8">
                      <div className="inline-block h-6 w-comAns">
                        {t("cms.subCategory")}
                      </div>
                    </th>
                    <th
                      className=" hover:text-ft-light cursor-pointer h-8"
                      onClick={() => handleOrder("effectiveDateFrom")}>
                      <div className="inline-block h-6 w-tableDate">
                        {t("common.publishDate")}
                        <svg
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          className="inline-block w-4 h-4 ml-1">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path>
                        </svg>
                      </div>
                    </th>
                    <th
                      className=" hover:text-ft-light cursor-pointer h-8"
                      onClick={() => handleOrder("effectiveDateTo")}>
                      <div className="inline-block h-6 w-tableDate">
                        {t("common.expiryDate")}
                        <svg
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          className="inline-block w-4 h-4 ml-1">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path>
                        </svg>
                      </div>
                    </th>
                    <th
                      className=" hover:text-ft-light cursor-pointer h-8"
                      onClick={() => handleOrder("file1Name")}>
                      <div className="inline-block h-6 w-file mr-2">
                        {t("common.file")}(1)
                        <svg
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          className="inline-block w-4 h-4 ml-1">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path>
                        </svg>
                      </div>
                    </th>
                    <th
                      className=" hover:text-ft-light cursor-pointer h-8"
                      onClick={() => handleOrder("file2Name")}>
                      <div className="inline-block h-6 w-file mr-2">
                        {t("common.file")}(2)
                        <svg
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          className="inline-block w-4 h-4 ml-1">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path>
                        </svg>
                      </div>
                    </th>
                    <th
                      className=" hover:text-ft-light cursor-pointer h-8 "
                      onClick={() => handleOrder("file3Name")}>
                      <div className="inline-block h-6 w-file mr-2">
                        {t("common.file")}(3)
                        <svg
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          className="inline-block w-4 h-4 ml-1">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path>
                        </svg>
                      </div>
                    </th>

                    {functionList.includes(
                      String(functionConstants.DOCUMENT_CENTER_EDIT)
                    ) ? (
                      <>
                        <th className=" h-8">
                          <div className="inline-block h-6 w-16">
                            {t("common.edit")}
                          </div>
                        </th>
                      </>
                    ) : (
                      <></>
                    )}
                    {functionList.includes(
                      String(functionConstants.DOCUMENT_CENTER_DELETE)
                    ) ? (
                      <>
                        <th className="w-tableDelete">{t("common.delete")}</th>
                      </>
                    ) : (
                      <></>
                    )}
                  </tr>
                </thead>
                <tbody className="text-left text-content">
                  {campaigns.map((campaign) => {
                    const startDate = new Date(campaign.effectiveDateFrom);
                    const endDate = new Date(campaign.effectiveDateTo);
                    const formattedStartDate = startDate
                      .toISOString()
                      .slice(0, 10);
                    const formattedEndDate =
                      endDate.toISOString().slice(0, 10) === "2099-12-31"
                        ? "N/A"
                        : endDate.toISOString().slice(0, 10);

                    if (campaign.file1Name === null) {
                      campaign.file1Name = "";
                    }
                    campaign.mainCategoryId = String(campaign.mainCategoryId);
                    campaign.subCategoryId = String(campaign.subCategoryId);

                    if (campaign.level2CategoryId === null) {
                      campaign.level2CategoryId = "";
                    }

                    const isExpired =
                      new Date() >= endDate ? <>{t("common.expired")}</> : null;

                    const isUnposted =
                      new Date() <= startDate ? (
                        <>{t("common.unposted")}</>
                      ) : null;

                    return (
                      <tr
                        className="border border-slate-300 h-16 "
                        key={campaign.documentCenterId}>
                        <td className="">
                          <div className=" pl-5 items-center w-docName line-clamp-2">
                            <Tooltip
                              title={
                                savedLanguage === "en"
                                  ? campaign.titleEng
                                  : savedLanguage === "cn"
                                  ? campaign.titleCn
                                  : campaign.titleHk
                              }
                              arrow>
                              <a
                                className="no-underline text-ft-light cursor-pointer hover:text-ft"
                                onClick={() => viewDocument(campaign)}>
                                {isExpired}
                                {isUnposted}
                                {savedLanguage === "en"
                                  ? campaign.titleEng
                                  : savedLanguage === "cn"
                                  ? campaign.titleCn
                                  : campaign.titleHk}
                              </a>
                            </Tooltip>
                          </div>
                        </td>
                        <td className="">
                          <div className="w-comAns line-clamp-2  items-center align-middle">
                            {categories
                              .filter(
                                (cat) =>
                                  cat.categoryId === campaign.mainCategoryId
                              )
                              .map((mainCat) => {
                                return (
                                  <>
                                    <Tooltip
                                      title={
                                        savedLanguage === "en"
                                          ? mainCat.categoryNameEng
                                          : savedLanguage === "cn"
                                          ? mainCat.categoryNameCn
                                          : mainCat.categoryNameHk
                                      }
                                      arrow>
                                      {savedLanguage === "en"
                                        ? mainCat.categoryNameEng
                                        : savedLanguage === "cn"
                                        ? mainCat.categoryNameCn
                                        : mainCat.categoryNameHk}
                                    </Tooltip>
                                  </>
                                );
                              })}
                          </div>
                        </td>
                        <td className="">
                          <div className="mr-5 w-comAns line-clamp-2 items-center align-middle">
                            {categories
                              .filter(
                                (cat) =>
                                  cat.categoryId === campaign.mainCategoryId
                              )
                              .flatMap((mainCat) => {
                                if (mainCat.secondLevelCategoryList) {
                                  return mainCat.secondLevelCategoryList
                                    .filter(
                                      (subCat) =>
                                        subCat.categoryId ===
                                        campaign.subCategoryId
                                    )
                                    .map((mainCat) => {
                                      return (
                                        <>
                                          <Tooltip
                                            title={
                                              savedLanguage === "en"
                                                ? mainCat.categoryNameEng
                                                : savedLanguage === "cn"
                                                ? mainCat.categoryNameCn
                                                : mainCat.categoryNameHk
                                            }
                                            arrow>
                                            {savedLanguage === "en"
                                              ? mainCat.categoryNameEng
                                              : savedLanguage === "cn"
                                              ? mainCat.categoryNameCn
                                              : mainCat.categoryNameHk}
                                          </Tooltip>
                                        </>
                                      );
                                    });
                                }
                                return [];
                              })}
                          </div>
                        </td>
                        <td className="">
                          <div className="w-tableDate truncate items-center align-middle">
                            {formattedStartDate}
                          </div>
                        </td>
                        <td className="">
                          <div className="w-tableDate truncate items-center align-middle">
                            {formattedEndDate}
                          </div>
                        </td>
                        <td className="">
                          <div className="w-file line-clamp-2 items-center align-middle">
                            <Stack>
                              <Grid container rowSpacing={1}>
                                {campaign.file1Name && (
                                  <FileDownloadButton
                                    fileId={campaign.file1Id}
                                    fileName={campaign.file1Name}
                                  />
                                )}
                              </Grid>
                            </Stack>
                          </div>
                        </td>
                        <td className="">
                          <div className="w-file line-clamp-2 items-center align-middle">
                            <Stack>
                              <Grid container rowSpacing={1}>
                                {campaign.file2Name && (
                                  <FileDownloadButton
                                    fileId={campaign.file2Id}
                                    fileName={campaign.file2Name}
                                  />
                                )}
                              </Grid>
                            </Stack>
                          </div>
                        </td>
                        <td className="">
                          <div className="w-file line-clamp-2 items-center align-middle">
                            <Stack>
                              <Grid container rowSpacing={1}>
                                {campaign.file3Name && (
                                  <FileDownloadButton
                                    fileId={campaign.file3Id}
                                    fileName={campaign.file3Name}
                                  />
                                )}
                              </Grid>
                            </Stack>
                          </div>
                        </td>
                        {functionList.includes(
                          String(functionConstants.DOCUMENT_CENTER_EDIT)
                        ) ? (
                          <>
                            <td className="">
                              <a
                                className="cursor-pointer"
                                onClick={() => EditDocument(campaign)}>
                                <Icon src="edit" color="primary" />
                              </a>
                            </td>
                          </>
                        ) : (
                          <></>
                        )}
                        {functionList.includes(
                          String(functionConstants.DOCUMENT_CENTER_DELETE)
                        ) ? (
                          <>
                            <td className=" pr-3 h-8 mb-1">
                              <div className="w-talbeDelete">
                                <a
                                  className="cursor-pointer"
                                  onClick={() =>
                                    handleDelete(campaign.documentCenterId)
                                  }>
                                  <Icon src="delete" color="primary" />
                                </a>
                              </div>
                            </td>
                          </>
                        ) : (
                          <></>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="flex items-center justify-between px-4 py-3 md:px-6 text-content">
            <div className="hidden md:flex md:flex-1 md:items-center md:justify-between">
              <div>
                {pagination.totalNumberOfRecords === 0 ? (
                  <p className="text-sm text-gray-700">
                    {t("common.noRecord")}
                  </p>
                ) : (
                  <p className="text-sm text-gray-700">
                    {t("common.showPage1")}
                    <span className="font-medium"> {preResult}</span>{" "}
                    {t("common.showPage2")}{" "}
                    <span className="font-medium">{nextResult}</span>{" "}
                    {t("common.showPage3")}{" "}
                    <span className="font-medium">
                      {pagination.totalNumberOfRecords}
                    </span>{" "}
                    {t("common.showPage4")}
                  </p>
                )}
              </div>
              <div>
                {pagination && pagination.totalNumberOfRecords > 0 && (
                  <Stack spacing={2}>
                    <Pagination
                      page={parseInt(pagination.pageNumber) + 1}
                      shape={"circular"}
                      count={
                        pagination.totalNumberOfRecords &&
                        pagination.pageSize &&
                        !isNaN(pagination.totalNumberOfRecords) &&
                        !isNaN(pagination.pageSize)
                          ? Math.ceil(
                              pagination.totalNumberOfRecords /
                                pagination.pageSize
                            )
                          : 0
                      }
                      onChange={(e, value) => handlePageChange(value)}
                    />
                  </Stack>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DocCenter;
